import * as lambda from "@/api/lambda.js";
import * as spotv from "@/api/spotv.js";
import * as brightcove from "@/api/brightcove.js";
import * as deviceApi from "@/api/smartTv.js";
import * as websocket from "@/api/ws.js";
import router from "@/routes/index.js";
import Vue from "vue";

export default {
  FETCH_LAMBDA_INFO(context, params) {
    return lambda
      .fetchLambda({
        version: process.env.VUE_APP_LAMBDA_VERSION,
        platform: "stv",
      })
      .then((response) => {
        if (process.env.VUE_APP_OS_TYPE == "pc") {
          // default baseUrl 값을 process.env.BASE_URL 사용하고 있음 추후 제거 확인 필요.
          spotv.setBaseUrl(process.env.BASE_URL);
        } else {
          spotv.setBaseUrl(response.data.api);
        }

        context.commit("SET_LAMBDA_INFO", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_LAMBDA_INFO -> ", error);
        // 2020.03.10 zaehun@tlab.co.kr
        // lambdaInfo api 연동 실패시 default 값 사용하도록 수정
        context.commit("SET_LAMBDA_INFO", {});
        // errorCatcher(error);
        return error;
      });
  },

  FETCH_SPLASH(context) {
    return spotv
      .fetchSplash()
      .then((response) => {
        context.commit("SET_SPLASH_PATH", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_SPLASH -> ", error);
        errorCatcher(error);
        return error;
      });
  },

  REGIST_DEVICE(context, params) {
    return spotv
      .registDevice({
        key: params.uuid,
        deviceId: params.deviceId,
      })
      .then((response) => {
        console.log("REGIST_DEVICE success");
        return response;
      })
      .catch((error) => {
        console.log("REGIST_DEVICE -> ", error);
        errorCatcher(error);
        return error;
      });
  },

  VERIFY_DEVICE(context, uuid) {
    return spotv
      .deviceVerify({
        key: uuid,
      })
      .then((response) => {
        console.log("VERIFY_DEVICE success");
        switch (response.data.result) {
          case "expired time":
            break;
          case "fail":
            break;
          default:
            // 연결 성공
            context.commit("SET_LOGIN_ID", response.data.result);
        }
        return response;
      })
      .catch((error) => {
        console.log("VERIFY_DEVICE -> ", error);
        return error;
      });
  },

  EXTEND_OTP_TIME(context, uuid) {
    return spotv
      .extendOtpTime({
        key: uuid,
      })
      .then((response) => {
        console.log("EXTEND_OTP_TIME success");
        return response;
      })
      .catch((error) => {
        console.log("EXTEND_OTP_TIME -> ", error);
        return error;
      });
  },

  REQUEST_LOGIN(context, params) {
    console.log("REQUEST_LOGIN");

    return spotv
      .login({
        sns: "stv",
        username: params.name,
        deviceId: params.deviceId,
        key: params.uuid,
      })
      .then((response) => {
        console.log("REQUEST_LOGIN success");
        context.commit("SET_USER_INFO", response.data);

        // WEB 소켓 연결
        websocket.connectWs(
          context.getters.lambdaInfo.w_login,
          response.data.userId,
        );

        return response;
      })
      .catch((error) => {
        console.log("REQUEST_LOGIN -> ", error);
        return error;
      });
  },

  REQUEST_LOGOUT(context) {
    return spotv
      .logout()
      .then((response) => {
        console.log("REQUEST_LOGOUT success");
        // ID 삭제
        context.commit("REMOVE_LOGIN_DATA");
        context.commit("SET_USER_INFO", {});
        websocket.disconnectWs();
        return response;
      })
      .catch((error) => {
        console.log("REQUEST_LOGOUT -> ", error);
        errorCatcher(error);
        return error;
      });
  },

  FETCH_GET_SESSION(context) {
    return spotv
      .getSession()
      .then((response) => {
        console.log("FETCH_GET_SESSION success");
        context.commit("SET_USER_INFO", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_GET_SESSION -> ", error);

        errorCatcher(error);
        return error;
      });
  },
  FETCH_SESSION(context) {
    return spotv
      .postSession()
      .then((response) => {
        console.log("FETCH_SESSION success");
        return response;
      })
      .catch((error) => {
        console.log("FETCH_SESSION -> ", error);

        errorCatcher(error);
        return error;
      });
  },

  CHECK_SESSION(context) {
    Vue.prototype.$progress.$emit("off:progress").$emit("on:progress");
    return spotv
      .getSession()
      .then((response) => {
        Vue.prototype.$progress.$emit("off:progress").$emit("off:progress");
        console.log("CHECK_SESSION success");
        return response;
      })
      .catch((error) => {
        console.log("CHECK_SESSION -> ", error);
        Vue.prototype.$progress.$emit("off:progress").$emit("off:progress");
        errorCatcher(error);
        return false;
        // 테스트용 코드
        // return true;
      });
  },

  // LG deepLink가 들어오는 경우 session check
  DEEP_LINK_CHECK_SESSION(context) {
    return spotv.getSession();
  },

  FETCH_HOME_DATA(context) {
    return spotv
      .fetchHomeData()
      .then((response) => {
        context.commit("SET_HOME_DATA", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_HOME_DATA -> ", error);
        errorCatcher(error);
        return error;
      });
  },

  FETCH_HOME_HASH(context) {
    return spotv
      .fetchHomeHash()
      .then((response) => {
        let { webHashCode } = response.data,
          isUpdated = false;
        console.log("existedWebHashCode", context.getters.homeHash);
        console.log("currentWebHashCode", webHashCode);
        if (context.getters.homeHash !== webHashCode) {
          isUpdated = true;
        }

        context.commit("SET_HOME_HASH", webHashCode);
        return isUpdated;
      })
      .catch((error) => {
        console.log("FETCH_HOME_HASH -> ", error);
        errorCatcher(error);
        return error;
      });
  },

  FETCH_GAME_TYPE(context) {
    // context.commit("REMOVE_GAME_TYPE");

    return spotv
      .fetchGameType()
      .then((response) => {
        const data = response.data;

        let list = [];
        for (let i in data) {
          if (data[i].isHide == false) {
            data[i].cardType = "LEAGUE";
            data[i].title = data[i].name;
            data[i].list = [];
            list.push(data[i]);
          }
        }
        response.data = list;
        context.commit("SET_GAME_TYPE", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_GAME_TYPE -> ", error);
        errorCatcher(error);
        return error;
      });
  },

  FETCH_LEAGUE_DATA_BY_TYPEID(context, params) {
    return spotv
      .fetchLeagueByTypeId(params.id)
      .then((response) => {
        response.data.seqNo = params.seqNo;
        context.commit("SET_LEAGUE_DATA_BY_TYPEID", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_LEAGUE_DATA_BY_TYPEID -> ", error);
        return error;
      });
  },

  FETCH_LEAGUE_DATA_BY_LEAGUEID(context) {
    return spotv
      .fetchLeagueByLeagueId()
      .then((response) => {
        context.commit("FETCH_LEAGUE_DATA_BY_LEAGUEID", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_LEAGUE_DATA_BY_LEAGUEID -> ", error);
        return error;
      });
  },

  FETCH_ENTRY_DATA(context) {
    return spotv
      .fetchEntry()
      .then((response) => {
        context.commit("FETCH_ENTRY_DATA", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_ENTRY_DATA -> ", error);
        errorCatcher(error);
        return error;
      });
  },

  FETCH_PROGRAM_LIST(context) {
    return spotv
      .fetchProgramList()
      .then((response) => {
        context.commit("SET_PROGRAM_LIST", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_PROGRAM_LIST -> ", error);
        errorCatcher(error);
        return error;
      });
  },

  FETCH_PROGRAM_DETAIL_INFO(context, programId) {
    return spotv
      .fetchProgramInfo(programId)
      .then((response) => {
        context.commit("SET_PROGRAM_DETAIL_INFO", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_PROGRAM_DETAIL_INFO -> ", error);
        errorCatcher(error);
        return error;
      });
  },
  FETCH_PROGRAM_DETAIL_LIST(context, params) {
    return spotv
      .fetchProgramDetailList(params.programId, {
        pageItem: params.pageItem,
        pageNo: params.pageNo,
      })
      .then((response) => {
        if (params.pageNo === 1) {
          context.commit("SET_PROGRAM_DETAIL_LIST", response.data);
        } else {
          context.commit("APPEND_PROGRAM_DETAIL_LIST", response.data.list);
        }

        return response;
      })
      .catch((error) => {
        console.log("FETCH_PROGRAM_DETAIL_LIST -> ", error);
        errorCatcher(error);
        return error;
      });
  },

  FETCH_THEME_DETAIL_LIST(context, params) {
    return spotv
      .fetchThemeDetailList(params.themeId, {
        pageItem: params.pageItem,
        pageNo: params.pageNo,
      })
      .then((response) => {
        context.commit("SET_THEME_DETAIL_LIST", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_THEME_DETAIL_LIST -> ", error);
        a;
        errorCatcher(error);
        return error;
      });
  },
  FETCH_THEME_DETAIL_INFO(context, themeId) {
    return spotv
      .fetchThemeInfo(themeId)
      .then((response) => {
        context.commit("SET_THEME_DETAIL_INFO", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_THEME_DETAIL_INFO -> ", error);
        errorCatcher(error);
        return error;
      });
  },

  FETCH_YEAR_DATA_BY_LEAGUEID(context, params) {
    return spotv
      .fetchYearByLeagueId(params.leagueId)
      .then((response) => {
        context.commit("SET_YEAR_DATA_BY_LEAGUEID", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_YEAR_DATA_BY_LEAGUEID -> ", error);
        errorCatcher(error);
        return error;
      });
  },

  FETCH_LEAGUE_SEASON_LIST(context, params) {
    // context.commit('REMOVE_LEAGUE_SEASON_LIST');

    return spotv
      .fetchSeasonByLeagueId(params.leagueId)
      .then((response) => {
        context.commit("SET_LEAGUE_SEASON_LIST", {
          title: params.name,
          list: response.data,
        });
        return response;
      })
      .catch((error) => {
        console.log("FETCH_LEAGUE_SEASON_LIST -> ", error);
        errorCatcher(error);
        return error;
      });
  },

  FETCH_ROUND_LIST(context, params) {
    return spotv
      .fetchRound(params.id)
      .then((response) => {
        context.commit("SET_ROUND_LIST", response.data);
        // context.dispatch('FETCH_LEAGUE_VOD_LIST', params);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_ROUND_LIST -> ", error);
        errorCatcher(error);
        return error;
      });
  },

  FETCH_LEAGUE_VOD_LIST(context, params) {
    // context.commit('REMOVE_LEAGUE_VOD_LIST');

    context.commit("SET_LEAGUE_SEASON_ID", {
      gameType: params.gameType,
      leagueId: params.leagueId,
    });

    if (params.gameType == 2 || params.gameType == 8) {
      // 종합 격투기인 경우 기존 league/detail 사용
      return spotv
        .fetchLeagueVodList({
          gameType: params.gameType,
          leagueId: params.leagueId,
          seasonId: params.seasonId,
          teamId: params.teamId,
          roundId: params.roundId,
          year: params.year,
          pageNo: params.page,
          pageItem: params.pageItem,
        })
        .then((response) => {
          context.commit("SET_LEAGUE_VOD_LIST_TYPE2", response.data);
          return response;
        })
        .catch((error) => {
          console.log("FETCH_LEAGUE_VOD_LIST -> ", error);
          errorCatcher(error);
          return error;
        });
    } else {
      // league/detail/round 사용
      return spotv
        .fetchLeagueRoundVodList({
          gameType: params.gameType,
          leagueId: params.leagueId,
          seasonId: params.seasonId,
          page: params.page,
          pageItem: params.pageItem,
        })
        .then((response) => {
          context.commit("SET_LEAGUE_ROUND_VOD_LIST", response.data);
          return response;
        })
        .catch((error) => {
          console.log("FETCH_LEAGUE_VOD_LIST -> ", error);
          errorCatcher(error);
          return error;
        });
    }
  },

  FETCH_GAME_VOD_LIST(context, params) {
    return spotv
      .fetchGameVodList({
        gameId: params.gameId,
        vodType: params.vodType,
        sortType: params.sortType,
        pageNo: params.pageNo,
        pageItem: params.pageItem,
      })
      .then((response) => {
        context.commit("SET_GAME_VOD_LIST", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_GAME_VOD_LIST -> ", error);
        errorCatcher(error);
        return error;
      });
  },

  FETCH_TOP_BANNER_INFO(context) {
    return spotv
      .fetchTopBanner()
      .then((response) => {
        context.commit("SET_TOP_BANNER_INFO", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_TOP_BANNER_INFO -> ", error);
        return error;
      });
  },

  FETCH_SYSTEM_POPUP(context) {
    return spotv
      .fetchSystemPopup()
      .then((response) => {
        context.commit("SET_SYSTEM_POPUP", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_SYSTEM_POPUP -> ", error);
        // errorCatcher(error);
        return error;
      });
  },

  FETCH_TERMS(context, termId) {
    return spotv
      .fetchTerms(termId)
      .then((response) => {
        context.commit("SET_TERMS", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_TERMS -> ", error);
        errorCatcher(error);
        return error;
      });
  },

  async FETCH_USER_SUBSCRIPTION(context) {
    return await spotv
      .fetchUserSubscription()
      .then((response) => {
        context.commit("SET_USER_SUBSCRIPTION", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_USER_SUBSCRIPTION -> ", error);
        return error;
      });
  },

  async FETCH_CONTENTS_PERMISSION(context, params) {
    return await spotv
      .fetchContentsPermission(params)
      .then((response) => {
        context.commit("SET_CONTENTS_PERMISSION", response.data);
        context.commit("SET_USER_SUBSCRIPTION", response.data.subscription);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_CONTENTS_PERMISSION -> ", error);
        errorCatcher(error);
        return error.response;
      });
  },

  async FETCH_SERVICES(context, { platform }) {
    return await spotv
      .fetchServices({ platform })
      .then((response) => {
        context.commit("SET_SERVICES", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_SERVICES -> ", error);
        errorCatcher(error);
        return error.response;
      });
  },

  FETCH_VOD_DATA(context, vodId) {
    return spotv
      .fetchVodData(vodId)
      .then((response) => {
        context.commit("SET_VOD_DATA", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_VOD_DATA -> ", error);
        errorCatcher(error);
        return error;
      });
  },

  FETCH_LIVE_DATA(context, liveId) {
    return spotv
      .fetchLiveData(liveId)
      .then((response) => {
        context.commit("SET_VOD_DATA", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_LIVE_DATA -> ", error);
        errorCatcher(error);
        return error;
      });
  },

  FETCH_PLAYBACK_DATA(context, { videoId, adConfig = "" }) {
    const { brightcoveApi, policyKey } = context.getters.lambdaInfo;
    return brightcove
      .playbackVod(videoId, adConfig, brightcoveApi, policyKey)
      .then((response) => {
        context.commit("SET_PLAYBACK_DATA", response.data);
        return response;
      })
      .catch((error) => {
        console.log("FETCH_PLAYBACK_DATA -> ", error);
        errorCatcher(error);
        return error;
      });
  },

  FETCH_DEVICE_ID(context, successCallback, errorCallback) {
    deviceApi.getDeviceId(
      (deviceId) => {
        console.log("FETCH_DEVICE_ID : ", deviceId);
        context.commit("SET_DEVICE_ID", deviceId);
        if (successCallback) {
          successCallback(deviceId);
        }
      },
      (error) => {
        console.log("FETCH_DEVICE_ID -> ", error);
        if (errorCallback) {
          errorCallback();
        }
      },
    );
  },

  SEND_VIEW_LOG(context, params) {
    return spotv
      .sendViewLog(params.url, params.data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        console.log("SEND_VIEW_LOG -> ", error);
        return error;
      });
  },
};

function errorCatcher(error) {
  Vue.prototype.$progress.$emit("off:progress");
  if (error.response) {
    router.replace({
      name: "err-api",
      params: {
        errorCode: error.response.status,
      },
    });
  } else {
    console.log("Error", error.message);

    router.replace({
      name: "err-net",
    });
  }
}
